export default [
  {
    name: 'project_benefiting',
    component_path: 'modules/templates/blocks/project/ProjectBenefiting'
  }
]